
export interface Apps {
  name: string;
}


export class Member {
  public id: string;
  public avatar?: string;
  public fullname?: string;
  public email?: string;
  public jobtitle?: string;
  public about?: string;
  public phone?: string;

  public created_at: Date;
  public updated_at: Date;

  public supervisor: boolean;

  public permissions: string[];

  public inviting_email: string;
  public status: string;

  public pending_signup: boolean;


  constructor() {
    this.permissions = [];
    this.pending_signup = false;
    this.supervisor = false;

  }

  static create(jsonObject: any): Member {

    const o = new Member();
    o.id = jsonObject.id ? jsonObject.id : null;
    if (jsonObject.user) {

      o.email = jsonObject.user.email ? jsonObject.user.email : null;
      o.fullname = jsonObject.user.fullname ? jsonObject.user.fullname : null;
      o.avatar = jsonObject.user.avatar ? jsonObject.user.avatar : null;
      o.jobtitle = jsonObject.user.jobtitle ? jsonObject.user.jobtitle : null;
      o.phone = jsonObject.user.phone ? jsonObject.user.phone : null;
      o.about = jsonObject.user.about ? jsonObject.user.about : null;


    }

    if (!o.email) {
      o.email = jsonObject.inviting_email;
    }
    o.inviting_email = jsonObject.inviting_email ? jsonObject.inviting_email : null;
    o.pending_signup = jsonObject.user ? false : true;

    o.created_at = jsonObject.created_at ? jsonObject.created_at : null;
    o.updated_at = jsonObject.updated_at ? jsonObject.updated_at : null;
    o.status = jsonObject.status ? jsonObject.status : null;

    if (jsonObject.permissions) {
      for (const perm of jsonObject.permissions) {
        o.permissions.push(perm);
        if (perm == "ROLE_OWNER") {
          o.supervisor = true;
        }

        if (perm == "ROLE_SUPERVISOR") {
          o.supervisor = true;
        }

      }
    }

    return o;
  }

  get isBoutique() {
    if (this.permissions.includes('ROLE_OWNER') === true) {
      return true;
    }
    return this.permissions.includes('ROLE_BOUTIQUE');
  }
  get isCanvas() {
    if (this.permissions.includes('ROLE_OWNER') === true) {
      return true;
    }
    return this.permissions.includes('ROLE_CANVAS');
  }

  get isDashboard() {
    if (this.permissions.includes('ROLE_OWNER') === true) {
      return true;
    }
    return this.permissions.includes('ROLE_DASHBOARD');
  }

  get isAiAgent() {
    if (this.permissions.includes('ROLE_OWNER') === true) {
      return true;
    }
    return this.permissions.includes('ROLE_AI_AGENT');
  }
  // NEW ROLS SYSTEM 
  get isOwner() {
    return this.permissions.includes('ROLE_OWNER');
  }
  get isSupervisor() {
    return this.permissions.includes('ROLE_SUPERVISOR') || this.permissions.includes('ROLE_OWNER');
  }


}

export class AddMember {
  public email: string;
  public plan: string;
  public roles: string[];
  public comment: string;
  public productKey: string;

  constructor() {
    this.roles = [];
  }

  static create(jsonObject: any): AddMember {
    const o = new AddMember();

    o.email = jsonObject.user.email ? jsonObject.user.email : null;
    o.plan = jsonObject.user.plan ? jsonObject.user.plan : null;
    o.comment = jsonObject.user.comment ? jsonObject.user.comment : null;
    o.productKey = jsonObject.user.productKey ? jsonObject.user.productKey : null;
    return o;
  }
}

export class RolMember {
  public member_id: string;
  public permissions: string[];

  constructor() {
    this.permissions = [];
  }

  static create(jsonObject: any): RolMember {
    const o = new RolMember();
    o.member_id = jsonObject.member_id ? jsonObject.member_id : null;
    return o;
  }
}
export class PlanMember {
  public member_id: string;
  public plan: string;

  constructor() { }

  static create(jsonObject: any): PlanMember {
    const o = new PlanMember();
    o.member_id = jsonObject.member_id ? jsonObject.member_id : null;
    o.plan = jsonObject.plan ? jsonObject.plan : null;
    return o;
  }
}

export class SubscriptionMember {
  public member_id: string;

  static create(jsonObject: any): SubscriptionMember {
    const o = new SubscriptionMember();
    o.member_id = jsonObject.member_id ? jsonObject.member_id : null;
    return o;
  }
}
